import { z } from 'zod';
/**
 * A url a member supplied, restricted to the two schemes the product means.
 *
 * `z.string().url()` is NOT that check: it parses with the URL constructor,
 * which happily accepts `javascript:alert(1)`, `data:text/html;base64,...`,
 * `file:///etc/passwd` and `vbscript:`. Those are valid URLs and completely
 * wrong values for a website or an image, and they only look harmless until
 * something hands one to a browser or an OS.
 *
 * Something does. The profile screen passes a member's `website` straight to
 * `Linking.openURL`, so the scheme decides what the phone is asked to do with
 * it — open a page, or open another app, or read a local file. Validating the
 * SHAPE of a url while ignoring its scheme checks the half that was never the
 * risk.
 *
 * So this is an allowlist, not a denylist: http and https, and nothing else
 * unless someone adds it here deliberately. A denylist of `javascript:` and
 * friends would be a guess about which schemes exist, and it would be wrong
 * about `intent:`, `blob:`, and whatever ships next.
 *
 * The bound is 2048 characters — comfortably past any real url, short of a
 * megabyte data uri arriving in a text field.
 */
export const HttpUrl = z
    .string()
    .trim()
    .max(2_048)
    .url()
    .refine((value) => {
    // The URL constructor already succeeded (`.url()` ran first), so this
    // only reads the scheme back rather than re-parsing defensively.
    try {
        const { protocol } = new URL(value);
        return protocol === 'http:' || protocol === 'https:';
    }
    catch {
        return false;
    }
}, { message: 'Must be an http(s) URL' });
//# sourceMappingURL=url.js.map